import * as actionTypes from "./actionTypes";

export const setExceptionReporting = (exceptionReportConf) => {
  return {
    exceptionReportConf,
    type: actionTypes.SET_EXCEPTION_REPORT,
  };
};

export const unsetExceptionReporting = () => {
  return {
    type: actionTypes.UNSET_EXCEPTION_REPORT,
  };
};

export const showExceptionReporting = (dispatch, requestId) => {
  dispatch(
    setExceptionReporting({
      dismiss: () => {
        dispatch(unsetExceptionReporting());
      },
      requestId,
    }),
  );
};
